<template>
  <div>
    <boton-atras :nombre_ruta="'informesSHaciendaConac'"/>
    <section class="provicionesSalarialesEconomicas">
      <div class="col-md-12">
        <div class="container text-center mb-5">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">Proviciones salariales y economicas</h1>
      </div>
        <!-- <h6 class="text-center">2 Proyecto del Presupuesto de Egresos</h6> -->
        <construccion/>
        <span v-html="DateFormatText('2013-07-13')"></span>

      </div>
    </section>

    <!-- <div>
      <ul class="p-0">
        <li v-for="(item, i) in data" :key="i" class="p-0 mb-1">
          <a :href="urlServe+item.url_pdf" target="_blank" class="text-dark">{{ item.titulo }}</a>
        </li>
      </ul>
    </div> -->
  </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import ArmonizacionContable from "@/services/ArmonizacionContable/ArmonizacionContable.service.js";
const _serviciosArmonizacionContable = new ArmonizacionContable();
import botonAtras from '../../button-atras'
import Construccion from '../../Construccion.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
    name: 'provisionesSalarrialesEconomicas',
    components: { botonAtras, Construccion },
    mixins: [DateFormat],
    data() {
        return {
          data: []
        };
    },
    async created() {
        await this.getProvisionesSalarialesEconomicas();
    },
    methods: {
        async getProvisionesSalarialesEconomicas() {
            try {
                const response = await _serviciosArmonizacionContable.getProvisionesSalarialesEconomicas(mapFun.ProvisionesSalarialesEconomicas);
                this.data = response.data;

            } catch (error) {
                console.log('error', error.message);
            }
        }
    }
}
</script>
